export default __webpack_public_path__ + "static/media/toyota.d1187710.jpg";